<template>
  <div>
    <pdl-callout v-if="error" kind="warning">
      <template #content>
        <span v-html="error" />
      </template>
    </pdl-callout>
    <form action="#" :class="{'opacity-50': isLoading}" autocomplete="on" @submit.prevent="onSubmit">
      <form-group
        v-model="email"
        v-validate="'required|email'"
        type="email"
        name="email"
        :label="bp('guest.email')"
        :data-vv-as="bp('login.email')"
        :show-error-messages="true"
        :error="errors.first('email')"
      />
      <trek-button primary :disabled="isLoading" type="submit" @click="onSubmit">
        <span v-html="bp('checkout.guest')"></span>
      </trek-button>
    </form>
  </div>
</template>
<script>
import TrekButton from '@/components/TrekButton';
import FormGroup from '@/components/FormGroup';
import {PdlCallout} from '@pedal/pdl-callout';
import {UserApi} from '@/api/user';

export default {
  name: 'GuestCheckout',
  components: {FormGroup, TrekButton, PdlCallout},
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      email: '',
      error: '',
    };
  },
  watch: {
    isLoading(value) {
      if (value) {
        this.error = '';
      }
    },
  },
  methods: {
    getFormData() {
      return {
        email: this.email,
        CSRFToken: this.options.CSRFToken,
      };
    },
    async processGuestLogin() {
      try {
        this.isLoading = true;
        this.handleResponse(await UserApi.guestLogin(this.getFormData()));
      } catch (e) {
        this.error = this.bp('server.error');
        this.isLoading = false;
      }
    },
    handleResponse(redirectUrl) {
      if (!redirectUrl || redirectUrl.indexOf('error=true') > -1) {
        this.error = this.bp('server.error');
        this.isLoading = false;
      } else {
        window.location.href = redirectUrl;
      }
    },
    onSubmit() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.processGuestLogin();
        }
      });
    },
  },
};
</script>
